import { primitiveColorTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const checkbox = {
    root: {
        borderRadius: primitiveLayoutTokens.borderRadius,
        background: primitiveColorTokens.white[100],
        checkedBackground: primitiveColorTokens.white[100],
        filledBackground: primitiveColorTokens.white[100],
        checkedHoverBackground: primitiveColorTokens.white[100],
    },
    icon: {
        color: primitiveColorTokens.blue[800],
        checkedColor: primitiveColorTokens.blue[800],
        checkedHoverColor: primitiveColorTokens.blue[800],
    },
    css: () => {
        /**
         * Indeterminate Styles
         * Usage: apply .indeterminate to <p-checkbox /> elements. PrimeNG doesn't
         *        expose a CSS class for checkboxes with indeterminate states
         */
        const indeterminate = `
            .p-checkbox.indeterminate {
                .p-checkbox-box {
                    border-color: var(--p-checkbox-checked-border-color);
                }
            }
        `;

        return indeterminate;
    },
};
